module.exports = __webpack_public_path__ + "static/media/Stock 3.83dc924f.svg";